import { Box, Stack, Typography } from "@mui/material"
import type { Occurrence } from "../../interface/occurrences"
import { occurrenceTime } from "../../utils/occurrences"
import { OccurrenceEffects } from "./occurrenceEffects"
import { RawRecordedJson, RecordedValue } from "./recordedValue"

/** Never project a receipt through a current publication, channel or ADV catalog. */
export function OccurrenceDetails({ occurrence }: { occurrence: Occurrence }) {
  const fields: [string, unknown][] = [
    ["ID отправки", occurrence.id],
    ["Назначение", occurrence.purpose],
    ["Статус доставки", occurrence.status],
    ["Записанное размещение", occurrence.placementId],
    ["Записанная публикация", occurrence.publicationId],
    ["Ревизия публикации", occurrence.publicationRevision],
    ["Ревизия размещения", occurrence.placementRevision],
    ["Записанная версия шаблона", occurrence.templateVersionId],
    ["Записанный канал", occurrence.channelId],
    ["Отправляющий бот", occurrence.sendingBotId],
    ["Плановое время", occurrenceTime(occurrence.dueAt)],
    ["Создано", occurrenceTime(occurrence.createdAt)],
    ["Завершено", occurrenceTime(occurrence.completedAt)],
    ["Записанные messageIds", occurrence.messageIds],
    ["Media group ID", occurrence.mediaGroupId],
    ["Ошибка доставки", occurrence.error],
    ["Предупреждения", occurrence.warnings],
  ]
  return (
    <Stack spacing={2} sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
      <Typography variant="h5">Запись отправки</Typography>
      <Typography>
        Только зафиксированные данные. Отсутствующие legacy-поля не
        восстанавливаются из текущих ресурсов. Известные messageIds могут
        описывать лишь часть альбома.
      </Typography>
      <Box component="dl" sx={{ m: 0 }}>
        {fields.map(([label, value]) => (
          <Box key={label}>
            <Typography component="dt" fontWeight="bold">
              {label}
            </Typography>
            <Box component="dd" aria-label={label} sx={{ ml: 2 }}>
              <RecordedValue value={value} />
            </Box>
          </Box>
        ))}
      </Box>
      <OccurrenceEffects
        pin={occurrence.pin}
        deletePrevious={occurrence.deletePrevious}
      />
      <section aria-label="Зафиксированный snapshot">
        <Typography variant="h6">Зафиксированный snapshot</Typography>
        <RecordedValue value={occurrence.snapshot} />
      </section>
      <details>
        <summary>Исходная запись JSON (только чтение)</summary>
        <RawRecordedJson value={occurrence} />
      </details>
    </Stack>
  )
}
